import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { AppService } from 'src/_services/app.service';
import { AuthenticationService } from 'src/_services/authentication.service';
import { VoidBetsModalComponent } from '../bets-settlements/bets-settlements.component';
import { RiskBetsStatus } from 'src/_constants/bet_filters';

@Component({
  selector: 'app-risk-bets',
  templateUrl: './risk-bets.component.html',
  styleUrls: ['./risk-bets.component.scss']
})
export class RiskBetsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  selectedBetId = "";
  selectedEventId = "";
  selectedMarketId = "";
  selectedUserId = "";
  length: any = 0;
  displayTableColumns = [
    "Date",
    "Provider",
    "UserName",
    "Sport",
    "Operator",
    "Bet Id",
    "Event Name",
    "MarketName",
    "Odds",
    "Stake",
    // "Select Runner",
    "Result",
    "Actions",
  ];
  bets = [];
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  sportSettings: any = {};
  dropdownSettings: any = {};
  transactionfilter: boolean = false;
  eventidfilter: boolean = false;
  marketidfilter: boolean = false;
  useridfilter: boolean = false;
  operatorData = [];
  sports = [];
  selectedSport = new FormControl([]);
  ProviderId = new FormControl([]);
  OperatorId = new FormControl([]);
  selectedStatus = new FormControl([]); 
  providers = ["Exchange", "SportsBook"];
  statuses = RiskBetsStatus
  statusSettings: any = {};

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private activetedRoute: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit() {

    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };

    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };

    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.selectedStatus.setValue([this.statuses[0]])
    this.getEventBets();
    this.getOperatorData();
  }

  transactionfill() {
    this.transactionfilter = true;
  }

  eventidfill() {
    this.eventidfilter = true;
  }

  marketidfill() {
    this.marketidfilter = true;
  }

  useridfill() {
    this.useridfilter = true;
  }

  truncate(value: string, limit: number): string {
    if (value.length > limit) {
      return value.slice(0, limit) + (value.length > limit ? '...' : '');
    }
    return value;
  }

  copyText(val: string, event: MouseEvent){
    event.stopPropagation();
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }

  getEventBets() {
    try {
        let filters = {
          providerId: this.ProviderId.value.length === 0 ? "" : this.ProviderId.value[0],
          operatorId: this.OperatorId.value.length === 0 ? "" : this.OperatorId.value[0],
          sportId: this.selectedSport.value.length !== 0 ? this.selectedSport.value[0].SportId === 'All' ? "" : this.selectedSport.value[0].SportId : "",
          eventId: this.selectedEventId,
          marketId: this.selectedMarketId,
          betId: this.selectedBetId.toLowerCase(),
          userId: this.selectedUserId,
          page: this.page,
          pageSize: this.orgPageSize,
          status: this.selectedStatus.value.length !== 0 ? this.selectedStatus.value[0].id : "",
        }
     
      this.appService
        .getSettledOpenBets(filters)
        .subscribe((response) => {
          if (response.status === "RS_OK") {
            this.bets = [];
            if (this.page == 1) {
              this.length = response.totalCount;
            }
            let respbets = [];
              response.bets.forEach((bet) => {
                respbets.push({
                  ...bet,
                  isDisabled: false,
                  selectedRunnerId: bet.result.RunnerId,
                  selectedRunner: bet.result.RunnerName,
                  sessionOutcome: bet.result.SessionOutcome,
                })
              })
            this.bets = respbets;
            
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators
            .sort((a, b) => {
              let fa = a.operator_id.toLowerCase(),
                fb = b.operator_id.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            })
            .map((operator) => {
              return operator.operator_id;
            });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportData(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sports = res.sports;
          this.sports.unshift({ SportId: "All", SportName: "All Sports" });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.getSportsByProvider("BetFair");
    } else {
      this.getSportsByProvider("SportRadar");
    }
    this.page = 1;
    this.ProviderId.setValue([pid]);
    if (this.paginator) {
    this.paginator.pageIndex = 0;
    }
  };

  onSelectedOperatorId = (OperatorId) => {
    this.page = 1;
    this.OperatorId.setValue(OperatorId);
    this.paginator.pageIndex = 0;
  };

  getSelectedRunner(element) {
    if (element.result.RunnerId !== '') {
      return element.runners.find(runner => runner.RunnerId === element.result.RunnerId) || '';
    } else {
      return '';
    }
  }

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getEventBets();
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getEventBets();
  }

  setBetToSettle(data, index) {
    let value = this.bets[index];
    try {
      let filters = {
        betId: value.transactionId,
        runnerId: value.selectedRunnerId,
        runnerName: value.selectedRunner,
        sessionOutcome: isNaN(value.sessionOutcome) ? 0 : Number(value.sessionOutcome),
        status: value.status,
      }
      this.appService
        .betSettle(filters)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.authenticationService.openSnackBar(res.errorDescription);
          } else {
            this.authenticationService.openErrorSnackBar(res.errorDescription);
          }
          this.getEventBets();
        });
    } catch (err) {
      console.log(err);
      this.authenticationService.openErrorSnackBar(err);
    }
  }

  setBetToVoid(value) {
    try {
      let dialogRef = this.dialog.open(VoidBetsModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          transactionId: value.transactionId,
          level : "operator",
          status: value.status,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getEventBets();
        }
      });
    } catch (err) {
      console.log(err);
      this.authenticationService.openErrorSnackBar("invalid");
    }

  }

  onBetIdSelection(value) {
    this.selectedBetId = value.trim();
  }

  onBetIdSelectionClear() {
    if (this.selectedBetId == "" || this.selectedBetId == null) {
      this.transactionfilter = false;
    }
    this.selectedBetId = "";
  }

  onEventIdSelection(value) {
    this.selectedEventId = value.trim();
  }

  onEventIdSelectionClear() {
    if (this.selectedEventId == "" || this.selectedEventId == null) {
      this.eventidfilter = false;
    }
    this.selectedEventId = "";
  }

  onMarketIdSelection(value) {
    this.selectedMarketId = value.trim();
  }

  onMarketIdSelectionClear() {
    if (this.selectedMarketId == "" || this.selectedMarketId == null) {
      this.marketidfilter = false;
    }
    this.selectedMarketId = "";
  }

  onUserIdSelection(value) {
    this.selectedUserId = value.trim();
  }

  onUserIdSelectionClear() {
    if (this.selectedUserId == "" || this.selectedUserId == null) {
      this.useridfilter = false;
    }
    this.selectedUserId = "";
  }

  onSelectingRunner(runnerName, index) {
    const responseRunner = this.bets[index].runners.find(runner => runner.RunnerName === runnerName);
    this.bets[index] = {
      ...this.bets[index],
      isDisabled: false,
      selectedRunnerId: responseRunner.RunnerId,
      selectedRunner: responseRunner.RunnerName,
    };
  }

  onChangingSessionOutcome(sessionOutcome, index) {
    this.bets[index] = {
      ...this.bets[index],
      isDisabled: sessionOutcome ? false : true,
      sessionOutcome: sessionOutcome,
    };
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'e' || event.key === '-' || event.key === '+') {
      event.preventDefault();
    }
  }

  openDialog(bet: any) {
    this.dialog.open(RiskBetsModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: [
        { key: 'User Name', value: bet.userName },
        { key: 'User Id', value: bet.userId },
        { key: 'Bet Id', value: bet.transactionId },
        { key: 'Bet Time', value: this.convertDate(bet.betTime) },
        { key: 'Event Id', value: bet.eventId },
        { key: 'Event Name', value: bet.eventName },
        { key: 'Market Id', value: bet.marketId },
        { key: 'Market Name', value: bet.marketName },
        { key: 'Bet On', value: bet.betOn },
        { key: 'Bet Type', value: bet.betType },
        { key: 'Result Time', value: this.convertDate(bet.result.ResultTime * 1000) },
      ],
    });
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./risk-bets-modal.html",
  styleUrls: ["./risk-bets.component.scss"],
})
export class RiskBetsModalComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
  }
}